import React from "react";
import { Callback } from "../../components/auth/callback";

const CallbackPage = () => {
  return <Callback />;
};

export default CallbackPage;
